export default {
  state: {
    chart: {
      data: []
    }
  },
  actions: {
    async fetchChartData({ commit }, locale) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_BASE_API}${locale}/api/v1/materials/get-statistic`
        );
        const { content } = await response.json();
        commit(
          "setChartData",
          Object.values(content).map(value => +value)
        );
      } catch (e) {
        console.error(e);
        throw e;
      }
    }
  },
  mutations: {
    setChartData(state, data) {
      state.chart.data = data;
    }
  },
  getters: {
    chartData: state => state.chart.data
  }
};
